import React from "react";

import { Menu } from "./Menu";
import { PageView as PageViewComponent } from "./PageView";
import { StateManager } from "./StateManager";
import { TextView as TextViewComponent } from "./TextView";
import { Block, Image, State } from "./types";

import "./styles.scss";
import { ReadingPagination } from "./PageView/pagination";

type Props = Readonly<{
  images: ReadonlyArray<Image>;
  initialBlocks: ReadonlyArray<Block>;
  onReset: () => Promise<void>;
  onSave: (state: State) => Promise<void>;
  onSubmit: (state: State) => Promise<void>;
  readonly: boolean;
  working: boolean;
}>;

const GUTTER_WIDTH = 15;
const PageView = React.memo(PageViewComponent);
const TextView = React.memo(TextViewComponent);

const ReadingComponent = ({
  images,
  initialBlocks,
  onReset,
  onSave,
  onSubmit,
  readonly,
  working,
}: Props) => {
  return (
    <StateManager initialBlocks={initialBlocks} readonly={readonly} images={images}>
      {({ dispatch, state }) => {
        return (
          <div className="reading">
            <div className="left">
              <PageView
                dispatch={dispatch}
                gutterWidth={GUTTER_WIDTH}
                images={images}
                state={state}
              />
              { (state.pageSize != images.length) &&
                <ReadingPagination
                  dispatch={dispatch}
                  images={images}
                  state={state}
                />
              }
            </div>
            <div className="right">
              <Menu
                disabled={readonly || working}
                dispatch={dispatch}
                showReadingOrder={state.showReadingOrder}
                onReset={onReset}
                onSave={() => {
                  onSave(state);
                }}
                onSubmit={() => {
                  onSubmit(state);
                }}
              />
              <TextView dispatch={dispatch} state={state} />
            </div>
          </div>
        );
      }}
    </StateManager>
  );
};
ReadingComponent.displayName = "Reading";
export const Reading = React.memo(ReadingComponent);
